import { NotificationType } from "@cirrus/legacy/features/core/shared/constants/notification.js"
import { map } from "ramda"
import shortid from "shortid"

export const types = {
  NOTIFICATION_HIDDEN: "NOTIFICATION/NOTIFICATION_HIDDEN",
  NOTIFICATION_SHOWN: "NOTIFICATION/NOTIFICATION_SHOWN",
  NOTIFICATIONS_HIDDEN: "NOTIFICATION/NOTIFICATIONS_HIDDEN",
  NOTIFICATIONS_SHOWN: "NOTIFICATION/NOTIFICATIONS_SHOWN",
  RESET: "NOTIFICATION/RESET"
}

const getDefaultNotification = () => ({
  autohideMilliseconds: 3500,
  htmlEnabled: false,
  id: shortid.generate(),
  isAutohideEnabled: true,
  isHideEnabled: true,
  type: NotificationType.info,
})

export const creators = {
  notificationHidden: (id) => ({
    payload: {
      id,
    },
    type: types.NOTIFICATION_HIDDEN,
  }),
  notificationsHidden: (ids) => ({
    payload: {
      ids,
    },
    type: types.NOTIFICATIONS_HIDDEN,
  }),
  notificationShown: (notification) => ({
    payload: {
      notification: {
        ...getDefaultNotification(),
        ...notification,
      },
    },
    type: types.NOTIFICATION_SHOWN,
  }),
  notificationsShown: (notifications) => ({
    payload: {
      notifications: map(
        (notification) => ({
          ...getDefaultNotification(),
          ...notification,
        }),
        notifications,
      ),
    },
    type: types.NOTIFICATIONS_SHOWN,
  }),
  reset: () => ({
    type: types.RESET
  })
}
